import { Injectable } from '@angular/core';
import { HttpClient ,HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable,throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { GlobalService } from './../core/global.service';
import { ChangeLogLoanItem } from './models/changeLogLoanItem'
import { ChangeLogDataRequestParams } from './models/auctionRequest'
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { PaginationParams } from './models/loanItem';

@Injectable({
  providedIn: 'root'
})

export class ChangeLogService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'eqcpcc': this._global.find((<any>_GlobalNS).paths.eqcpcc)
    })
  };

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  getChangeLogData(requestparms: ChangeLogDataRequestParams,paginationParams: PaginationParams): Observable<any> {
    const api = (<any>_GlobalNS).api.auction.changeLog;
    let params = new HttpParams().set('LoanNumber', requestparms.loanNumber)
                                 .set('changedBy', requestparms.changedBy)
                                 .set('dateFrom', requestparms.dateFrom)
                                 .set('dateTo', requestparms.dateTo)
                                 .set('RecordOffset', paginationParams.offset.toString())
                                 .set('PageRecords', paginationParams.pageSize.toString())
                                 .set('SortDir', paginationParams.sortDir.toString())
                                 .set('SortValue', paginationParams.sortValue.toString())
                                 .delete('changedBy', '')
                                 .delete('LoanNumber', '')
                                 .delete('dateFrom', '')
                                 .delete('dateTo', '');

    this.httpOptions['params'] = params;
    return this._http.get<any>(`${api}`,this.httpOptions)
              .pipe(
                map((response)=> {return this.formatChangeLogData(response)}),
                catchError(error => {return throwError(error)})
              );
  }

  formatChangeLogData(res) {
    let formattedData =  res;
    formattedData.data = this.getData(res);
    return formattedData;
  }

  getData(res) : ChangeLogLoanItem[]{
    let changeLogItems: ChangeLogLoanItem[] = [];
    res.data.map((item) => {
      let tempdata: ChangeLogLoanItem;
      tempdata = {
        auctionUpdateHistoryID: item.AuctionUpdateHistoryID,
        initialReservePricePercentageOld: item.InitialReservePricePercentageOld !== null  ? Number(item.InitialReservePricePercentageOld.toFixed(2)) : item.InitialReservePricePercentageOld,
        initialReservePricePercentageNew: item.InitialReservePricePercentageNew,
        UpdateStatusValue: item.UpdateStatusValue,
        reservePriceOld: item.ReservePriceOld,
        reservePriceNew: item.ReservePriceNew,
        reservePriceReductionPercentageOld: item.ReservePriceReductionPercentageOld !== null ? Number(item.ReservePriceReductionPercentageOld.toFixed(2)) : item.ReservePriceReductionPercentageOld,
        reservePriceReductionPercentageNew: item.ReservePriceReductionPercentageNew,
        loanNumber: item.LoanNumber,
        changeDate: item.UpdateDate,
        changedBy: item.UpdateOperatorName
      }
      changeLogItems.push(tempdata);
    });
    return changeLogItems;
  }

  getChangeLogDataSelectors(): Observable<any>{
    const api = (<any>_GlobalNS).api.auction.changeLogSelectors;
    return this._http.get<any>(`${api}`)
            .pipe(
              map((response) => {return this.formatSelectors(response)}),
              catchError(error => {return throwError(error)})
            );
  }

  formatSelectors(res) {
    const data = {
      loans : this.getLoans(res.data[0].Loan),
      changedBy : this.getChangedByUsers(res.data[0].ChangedBy)
    }
    return data;
  }

  getLoans(data) {
    let loans = [];
    let tempArray: any = {};
    data.map((items) => {
      tempArray = {
        name: items.LoanNumber,
        code: items.LoanNumber
      }
      loans.push(tempArray);
    })
    return loans;
  }

  getChangedByUsers(data) {
    let changedBy = [];
    let tempArray: any = {};
    data.map((items) => {
      tempArray = {
        name: items.ChangedByName,
        code: items.ChangedById
      }
      changedBy.push(tempArray);
    })
    return changedBy;
  }

}